export default [
  { id: 1, 작업내용: '도장공사',
    유해위험요인: '인력으로 자재 운반 중 요통재해 발생',
    개선대책: '1. 양중기, 리어카 등 운반용 기계기구 사용',
  },
  { id: 2, 작업내용: '도장공사',
    유해위험요인: '자재 적재장소에서 화기 사용 중 화재 발생',
    개선대책: '1. 도장용 자재는 환기가 잘 되는 장소에 보관 하고 \n    주변에서 화기 사용금지',
  },
  { id: 3, 작업내용: '도장공사',
    유해위험요인: '지게차로 자재 하역 중 지게차와 충돌',
    개선대책: '1. 지게차로 자재 하역시 신호수 배치하여 주변 통제조치',
  },
  { id: 4, 작업내용: '도장공사',
    유해위험요인: '도장용기를 불안전하게 적재하여 적재 중 무너짐',
    개선대책: '1. 도장용기는 적정한 높이로 편심이 발생되지 않도록 \n    안전하게 적재',
  },
  { id: 5, 작업내용: '도장공사',
    유해위험요인: '도장면 처리 중 핸드그라인더 톱날 파손으로 톱날 비산에 의한 안구 손상',
    개선대책: '1. 핸드그라인더 톱날 덮개 설치 및 보안경 착용',
  },
  { id: 6, 작업내용: '도장공사',
    유해위험요인: '유기용제 보관소 주변에서 화기 사용 중 화재 발생',
    개선대책: '1. 유기용제 보관소 주변에서 화기사용 금지\n' +
      '2. 소화기와 위험표지판 설치, 관리책임자 지정 및]\n    관리감독 철저',
  },
  { id: 7, 작업내용: '도장공사',
    유해위험요인: '비계에 작업발판을 설치하고 도장 면처리 작업 중 작업발판 탈락에 의한 추락',
    개선대책: '1. 작업발판 설치 시 발판고정\n' +
      '2. 안전난간대 설치, 전도방지 조치',
  },
  { id: 8, 작업내용: '도장공사',
    유해위험요인: '밀폐공간 환기 불량 및 호흡용 보호구 미착용으로 인한 질식',
    개선대책: '1. 밀폐공간 도장 작업시 환기 설비 설치 및 보안경, \n    방진마스크, 방독마스크 등 개인 보호구 착용',
  },
  { id: 9, 작업내용: '도장공사',
    유해위험요인: '지하공간에서 도장작업 시 조명설비 불량으로 \n이동 중 전도',
    개선대책: '1. 지하층에 안전한 작업 및 통행을 위해 충분한 조명설비 설치',
  },
  { id: 10, 작업내용: '도장공사',
    유해위험요인: '도장작업장소에서 용접작업 중 화재 발생',
    개선대책: '1. 도장작업장소에 용접 및 화기사용 금지 조치',
  },
  { id: 11, 작업내용: '도장공사',
    유해위험요인: '도장 배합용 전동공구에 누전차단기 미연결 또는 \n피복손상에 의한 감전',
    개선대책: '1. 전동공구에 누전차단기 연결사용, 작업용 전선 사전점검 및 전선의 가공처리',
  },
  { id: 12, 작업내용: '도장공사',
    유해위험요인: '고소작업대의 탑승 설비에 안전난간의 미설치로 \n도장 작업 중 추락',
    개선대책: '1. 고소 작업대의 탑승 설비에 안전난간대 설치 및 \n    안전대 착용',
  },
]
